import { render, staticRenderFns } from "./list-add-modal.vue?vue&type=template&id=5307770e&scoped=true"
import script from "./list-add-modal.vue?vue&type=script&lang=js"
export * from "./list-add-modal.vue?vue&type=script&lang=js"
import style0 from "./list-add-modal.vue?vue&type=style&index=0&id=5307770e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5307770e",
  null
  
)

export default component.exports